import ResizableScene from "../core/ResizableScene";

export class SnowParticles {
	static create(scene: ResizableScene, container: Phaser.GameObjects.Container): Phaser.GameObjects.Particles.ParticleEmitter[] {
		const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];
		for (const img of ["fallingSnow1", "fallingSnow2", "fallingSnow3"]) {
			const particles = scene.add.particles(img);
			container.add(particles);

			const emitter = particles.createEmitter({
				alpha: { start: 1, end: 0.0 },
				scale: { min: 0.7, max: 1.1 },
				frequency: 300,
				lifespan: 2500,
				speedX: { min: -50, max: 300 },
				speedY: { min: 150, max: 400 },
			});
			emitters.push(emitter);

			emitter.tint.onEmit = (p): number => {
				(<any>p).rotVel = Phaser.Math.RND.realInRange(-8, 8);
				return p.tint;
			};

			emitter.tint.onUpdate = (p, _k, t, _value): number => {
				p.rotation = t * (<any>p).rotVel;
				return p.tint;
			};

			emitter.start();

			scene.events.on(Phaser.Scenes.Events.UPDATE, (): void => {
				const offsetX = Phaser.Math.RND.realInRange(-3000, 500);
				emitter.setPosition(scene.cameras.main.scrollX + scene.viewport.width + offsetX, scene.cameras.main.scrollY - 300);
			});
		}
		return emitters;
	}

	static pauseEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.pause();
		}
	}

	static resumeEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.resume();
		}
	}
}
